import defaultLogo from '../assetts/images/RUNMYBOT_loginlogo.svg';
import defaultBg from '../assetts/images/RUNMYBOT_Loginpageimage.svg';
import defaultHeaderLogo from '../assetts/images/RUNMYBOT_headerlogo.svg';

const logoContext = require.context('../assetts/images', false, /_loginlogo\.svg$/i);
const bgContext = require.context('../assetts/images', false, /_Loginpageimage\.svg$/i);
const headerLogoContext = require.context('../assetts/images', false, /_headerlogo\.svg$/i);

// staging.runmybot.com -> STAGING
// www.runmybot.com     -> RUNMYBOT (www stripped)
// runmybot.com         -> RUNMYBOT
// localhost            -> LOCALHOST (falls back to default, no match expected)
const getHostnameKey = () => {
  const host = window.location.hostname;
  const parts = host.split('.').filter((p) => p !== 'www');
  return parts[0].toUpperCase();
};

export const getLogo = () => {
  const key = `./${getHostnameKey()}_loginlogo.svg`;
  try {
    return logoContext(key);
  } catch {
    return defaultLogo;
  }
};

export const getBgImage = () => {
  const key = `./${getHostnameKey()}_Loginpageimage.svg`;
  try {
    return bgContext(key);
  } catch {
    return defaultBg;
  }
};

export const getHeaderLogo = () => {
  const key = `./${getHostnameKey()}_headerlogo.svg`;
  try {
    return headerLogoContext(key);
  } catch {
    return defaultHeaderLogo;
  }
};